import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Editor = _resolveComponent("Editor")!

  return (_openBlock(), _createBlock(_component_Editor, {
    "hugerte-script-src": _ctx.hugerteScriptSrc,
    init: _ctx.options,
    modelValue: _ctx.text,
    "onUpdate:modelValue": _ctx.onModelUpdate,
    disabled: _ctx.disabled
  }, null, 8, ["hugerte-script-src", "init", "modelValue", "onUpdate:modelValue", "disabled"]))
}